// 用户信息
/* eslint-disable */
export function getParams(key) {
  const params = window.location.hash.split('?')[1] || window.location.search.slice(1)
  if (!params) return null
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const r = params.match(reg)

  if (r !== null) return r[2]

  return null
}
